import React, { useState } from 'react'
import commaNumber from 'comma-number'
import { useAlert } from 'react-alert'
import { useSearchParam } from 'react-use'
import backendApis from '../utils/backendApis'

const NewYearsMoneyInitialBonusModal = ({
  setShowNewYearsMoneyInitialBonusModal,
}) => (
  <>
    <div
      style={{
        flex: 1,
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        zIndex: 3,
        backgroundColor: 'rgba(0,0,0,0.8)',
        width: '100%',
        height: '100%',
      }}
    >
      {' '}
      <button
        type='button'
        style={{
          width: 100,
          height: 100,
          backgroundColor: 'red',
          background: 'none',
          border: 'none',
          top: '10%',
          right: '1%',
          position: 'absolute',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={() => {
          console.log(11111)
          setShowNewYearsMoneyInitialBonusModal(false)
        }}
      >
        <img
          style={{
            zIndex: 101,
            width: '36%',
            height: '36%',
            position: 'absolute',
          }}
          src='/images/closeCircleIcon.png'
          alt=''
        />
      </button>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
          alignItems: 'center',
          //   backgroundColor: 'red',
        }}
      >
        <div
          style={{
            fontSize: 24,
            fontFamily: 'GmarketSans',
            color: 'white',
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          <div>현금으로 출금 가능한</div>
          <div>
            <span style={{ color: '#FFF744' }}>세뱃돈 3,000원</span>을 받았어요
          </div>
        </div>
        <div
          style={{
            // backgroundColor: 'red',
            width: 264,
            height: 188,
            backgroundSize: 'cover',
            backgroundImage: "url('/images/newYearsMoneyImage.png')",
            // marginBottom: 12,
            marginTop: 16,
            position: 'relative',
          }}
        />

        <div
          style={{
            backgroundColor: '#FFF744',
            padding: 8,
            paddingTop: 12,
            paddingBottom: 12,
            display: 'flex',
            justifyContent: 'center',
            borderRadius: 8,
            margin: 8,
            marginBottom: 20,
            width: '64%',
            fontFamily: 'GmarketSans',
            fontWeight: 'bold',
            color: 'black',
          }}
        >
          <button
            type='button'
            style={{
              background: 'none',
              border: 'none',
              fontFamily: 'GmarketSans',
              fontWeight: 900,
              fontSize: 20,
              width: '100%',
              height: '100%',
            }}
            onClick={() => {
              setShowNewYearsMoneyInitialBonusModal(false)
            }}
          >
            {' '}
            닫기
          </button>
        </div>
      </div>
    </div>
  </>
)

export default NewYearsMoneyInitialBonusModal
